import React from 'react';
import { IconType } from 'react-icons';
import './ActionButton.scss';

export interface ActionButtonProps {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'ghost' | 'info' | 'outline-primary' | 'outline-secondary' | 'outline-success' | 'outline-warning' | 'outline-danger';
  size?: 'sm' | 'md' | 'lg';
  icon?: IconType;
  iconPosition?: 'left' | 'right';
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  tooltip?: string;
  style?: React.CSSProperties;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  children,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  className = '',
  type = 'button',
  tooltip,
  style
}) => {
  const buttonClasses = [
    'action-button',
    `action-button--${variant}`,
    `action-button--${size}`,
    fullWidth ? 'action-button--full-width' : '',
    loading ? 'action-button--loading' : '',
    disabled ? 'action-button--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      title={tooltip}
      style={style}
    >
      {loading && (
        <div className="action-button__spinner">
          <div className="spinner"></div>
        </div>
      )}
      
      {!loading && Icon && iconPosition === 'left' && (
        <Icon className="action-button__icon action-button__icon--left" />
      )}
      
      {children && (
        <span className="action-button__text">{children}</span>
      )}
      
      {!loading && Icon && iconPosition === 'right' && (
        <Icon className="action-button__icon action-button__icon--right" />
      )}
    </button>
  );
};

export default ActionButton;
